/**
 * Rôles définis — natifs et dérivés (ADR 0006).
 *
 * Un rôle défini porte un code, un libellé et ses permissions effectives ; sa
 * **base** est l'un des quatorze rôles du CCT, et c'est elle que le reste du
 * code lit : second facteur, périmètre, dossier médical.
 */
import { z } from 'zod';
import { PERMISSIONS, ROLES } from '../constants/roles.js';
export const schemaCodeDeRole = z
    .string()
    .trim()
    .regex(/^[A-Z][A-Z0-9_]{1,59}$/, 'Code de rôle invalide.');
export const schemaLibelleDeRole = z
    .string()
    .trim()
    .min(2, 'Libellé trop court.')
    .max(80, 'Libellé trop long.');
export const schemaRoleDefini = z.object({
    code: schemaCodeDeRole,
    libelle: z.string(),
    description: z.string().nullable(),
    /** Le rôle du CCT dont il tient tout ce que le code doit savoir. */
    base: z.enum(ROLES),
    /** L'un des quatorze : créé par la migration, jamais désactivable. */
    natif: z.boolean(),
    /** Natif dont les permissions ont quitté la matrice du code. */
    personnalise: z.boolean(),
    actif: z.boolean(),
    /** Les permissions effectives — la matrice du code, ou ce qui a été réglé. */
    permissions: z.array(z.enum(PERMISSIONS)),
    /** Comptes qui le portent, supprimés exclus : c'est ce qui bloque la désactivation. */
    comptes: z.number().int(),
});
export const schemaCreationRole = z.object({
    libelle: schemaLibelleDeRole,
    description: z.string().trim().max(300).nullable(),
    base: z.enum(ROLES),
    permissions: z.array(z.enum(PERMISSIONS)).max(PERMISSIONS.length),
});
export const schemaModificationRole = z
    .object({
    libelle: schemaLibelleDeRole,
    description: z.string().trim().max(300).nullable(),
    permissions: z.array(z.enum(PERMISSIONS)).max(PERMISSIONS.length),
    actif: z.boolean(),
    /**
     * Revue S1041, A2 : la base d'un rôle ne change pas — sauf pour un dérivé
     * de SUPER_ADMIN resté d'avant la décision 418, que l'on rebase vers un
     * rôle ouvert (le serveur refuse tout autre cas).
     */
    base: z.enum(ROLES),
})
    .partial()
    .refine((valeur) => Object.keys(valeur).length > 0, {
    message: 'Aucune modification demandée.',
});
//# sourceMappingURL=roles.js.map